<template>
	<v-container v-if="initialized">
		<v-row class="mt-6">
			<v-col class="d-flex flex-column align-center text-center">
				<rmp-icon src="ico_ship"></rmp-icon>
				<rmp-text tag="span" type="body-large" class="mt-12" style="max-width: 420px">
					{{ tc("common.masterAccountAccessFinalStep.default") }}
				</rmp-text>
			</v-col>
		</v-row>
		<v-row style="margin-top: 80px">
			<v-col class="d-flex justify-center">
				<rmp-message-box type="success" icon="ico_success">
					{{ tc("alerts.info.youCanCloseCurrentBrowserPage") }}
				</rmp-message-box>
			</v-col>
		</v-row>
	</v-container>
</template>

<script setup lang="ts">
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpIcon from "@rmp/core/components/icon/RmpIcon.vue";
import RmpMessageBox from "@rmp/core/components/common/RmpMessageBox.vue";
import { useI18n } from "vue-i18n-composable";
import { useMasterAccountAccessDocumentsStepStore } from "@rmp/id/stores/masterAccountAccess/steps/documents";
import { computed } from "vue";
import { usePage } from "@rmp/core/composables/usePage";
import { useMasterAccountAccessStore } from "@rmp/id/stores/masterAccountAccess";
import { MasterAccountApplicationMethodTypeEnum } from "@rmp/id/stores/masterAccountAccess/types/MasterAccountApplicationMethodTypeEnum";

const { tc } = useI18n();

const applicationStore = useMasterAccountAccessStore();

const useStore = useMasterAccountAccessDocumentsStepStore;

const accessReceived = computed(() => {
	return [
		MasterAccountApplicationMethodTypeEnum.BY_EMPLOYEE,
		MasterAccountApplicationMethodTypeEnum.BY_SIGNATURE
	].includes(applicationStore.applicationMethod);
});

const moveToHomePage = async () => {
	(window as Window).location = "/";
};

const { initialized } = usePage({ useStore });
</script>
